<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF HOTEL MANAGEMENT & TOURISM</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Lab</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- PORTFOLIO 2 COLUMNS
================================================== -->
<section>
    <div class="container">
        <div class="section-heading">
            <span class="sub-title">Labs</span>
            <h2 class="h1 mb-0">Arni School of LAW</h2>
        </div>
        <div class="row mt-n1-9 portfolio-gallery">
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool08/1.jpg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL of TECHNOLOGY / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool08/1.jpg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool08/2.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL of TECHNOLOGY / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool08/2.jpeg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool08/3.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL of TECHNOLOGY / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool08/3.jpeg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool08/4.jpg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL of TECHNOLOGY / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool08/4.jpg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool08/5.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL of TECHNOLOGY / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool08/5.jpeg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool08/6.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL of TECHNOLOGY / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool08/6.jpeg" alt="...">
                </div>
            </div>
        </div>
    </div>
</section>
